import Grid from '@mui/material/Grid';
import React from 'react';
import ContentLinks from '../ContentLinks';
import AccordionContentLinks from '../ContentLinks/AccordionContentLinks';
import SocialMedia from '../SocialMedia';
import { LogoUrl } from './constants';
import * as S from './styles';
const ContentArea = ({ footerLinks, locale, hideSocialMediaHeading, socialMediaIcons, socialMediaHeading, }) => (React.createElement(S.GridContainer, { sx: { m: 0, pr: 0, pl: 0, pt: 6 } },
    React.createElement(Grid, { container: true, direction: {
            xs: 'column',
            sm: 'column',
            md: 'row',
        } },
        React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 6 },
            React.createElement(S.ImageContainer, null,
                React.createElement(S.CustomImage, { src: LogoUrl, alt: "Raisin logo" })),
            React.createElement(S.FooterDescription, { sx: { display: 'none' } }, "Als Pionier f\u00FCr Spar-, Investment- und Altersvorsorgeprodukte erm\u00F6glichen wir Privatkunden einen unkomplizierten Zugang zu globalen Einlagen- und Kapitalm\u00E4rkten \u2013 ein Vorteil, der auch Finanzinstitute st\u00E4rkt."),
            socialMediaIcons && (socialMediaIcons === null || socialMediaIcons === void 0 ? void 0 : socialMediaIcons.length) ? (React.createElement(SocialMedia, { icons: socialMediaIcons, heading: socialMediaHeading, hideHeading: hideSocialMediaHeading })) : null),
        React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 6, sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'block',
                },
            } },
            React.createElement(ContentLinks, { footerLinks: footerLinks, locale: locale })),
        React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, sx: {
                display: {
                    xs: 'block',
                    sm: 'block',
                    md: 'none',
                },
                mt: 8,
                mb: 8,
            } },
            React.createElement(AccordionContentLinks, { footerLinks: footerLinks, locale: locale })))));
export default ContentArea;
//# sourceMappingURL=index.js.map